import { useAppSelector } from "./use-store"
import { selectUserDetails, selectUserRoles } from "../../redux/slices/auth"
import {
  checkIsSuperAdmin,
  checkIsBankAdmin,
  checkIsLoanOfficer,
  checkIsAdmin
} from "../utils"

// Individual role-checking hooks
export const useIsSuperAdmin = () => {
  const roles = useAppSelector(selectUserRoles)
  return checkIsSuperAdmin(roles)
}

export const useIsBankAdmin = () => {
  const roles = useAppSelector(selectUserRoles)
  return checkIsBankAdmin(roles)
}

export const useIsLoanOfficer = () => {
  const roles = useAppSelector(selectUserRoles)
  return checkIsLoanOfficer(roles)
}

export const useIsAdmin = () => {
  const roles = useAppSelector(selectUserRoles)
  return checkIsAdmin(roles)
}

// Combined hook that returns all role checks
export const useUserRoles = () => {
  const user = useAppSelector(selectUserDetails)
  const roles = useAppSelector(selectUserRoles)
  const isSuperAdmin = checkIsSuperAdmin(roles)
  const isBankAdmin = checkIsBankAdmin(roles)
  const isLoanOfficer = checkIsLoanOfficer(roles)
  const isAdmin = checkIsAdmin(roles)

  return { isAdmin, isBankAdmin, isLoanOfficer, isSuperAdmin, roles, user }
}
